import { __decorate, __metadata } from "tslib";
import { dispatchEvent, isRTLCurrentLocale } from '@1inch-community/core/lit-utils';
import { isL2Chain } from '@1inch-community/sdk/chain';
import '@1inch-community/ui-components/icon';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { when } from 'lit/directives/when.js';
import { chainSelectorListItemStyle } from './chain-selector-list-item.style';
let ChainSelectorListItemElement = class ChainSelectorListItemElement extends LitElement {
    constructor() {
        super(...arguments);
        this.isActiveChain = false;
    }
    static { this.tagName = 'inch-chain-selector-list-item'; }
    static { this.styles = chainSelectorListItemStyle; }
    render() {
        if (this.info === undefined)
            return;
        const isL2 = isL2Chain(this.info.chainId);
        const classes = {
            container: true,
            active: this.isActiveChain,
        };
        const iconSize = 24;
        return html `
      <div class="${classMap(classes)}" @click="${() => this.onItemClick()}">
        ${when(isL2, () => html `
            <inch-icon icon="${isRTLCurrentLocale() ? 'l2ChainRTL24' : 'l2Chain24'}"></inch-icon>
          `)}
        <inch-icon
          width="${iconSize}px"
          height="${iconSize}px"
          icon="${this.info.iconName}"
        ></inch-icon>
        <span>${this.info.name}</span>
        <inch-icon
          class="list-icon"
          icon="${this.isActiveChain ? 'check24' : 'plus24'}"
        ></inch-icon>
        <inch-icon class="list-icon-delete" icon="minus24"></inch-icon>
      </div>
    `;
    }
    onItemClick() {
        if (!this.info)
            throw new Error('');
        dispatchEvent(this, 'chainItemClick', this.info);
    }
};
__decorate([
    property({ type: Object }),
    __metadata("design:type", Object)
], ChainSelectorListItemElement.prototype, "info", void 0);
__decorate([
    property({ type: Boolean, attribute: false }),
    __metadata("design:type", Boolean)
], ChainSelectorListItemElement.prototype, "isActiveChain", void 0);
ChainSelectorListItemElement = __decorate([
    customElement(ChainSelectorListItemElement.tagName)
], ChainSelectorListItemElement);
export { ChainSelectorListItemElement };
//# sourceMappingURL=chain-selector-list-item.element.js.map